export default __webpack_public_path__ + "static/media/mashoorah-logo-art-dark.cbc6476d.svg";